import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useStore } from "@/store/index";
import { updatePrivacySection } from "..";

export const useUpdatePrivacySection = () => {
    const queryClient = useQueryClient();
    const setSuccessMsg = useStore(state => state.setSuccessMsg);
    const setErrorMsg = useStore(state => state.setErrorMsg);

    return useMutation({
        mutationFn: updatePrivacySection,
        onSuccess: data => {
            queryClient.setQueryData(
                ["subscribed"],
                (oldData: { subscription: boolean } | undefined) => ({
                    subscription: !!oldData && data.subscription,
                })
            );
            setSuccessMsg("Privacy updated successfully");
        },
        onError: err => setErrorMsg(err as never),
    });
};
